import { SNC1W } from "../../data/OSSD/Grade9/SNC1W";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";


export default function SNC1WPage() {
    return (
        <div>
            <GradeCourseTemplate data={SNC1W} />
        </div>
    )
}